import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, CircleAlert, PackageOpen } from 'lucide-react';
import EmptyState from '@ajat/design-system/EmptyState';

/**
 * ShopEmptyState — shared "no products / could not load" state for the
 * shop-like listing pages (SchoolShop, MenuItemShop) across all brands: the
 * DS EmptyState with the two HelpCenter ways out (black Contact + outline
 * FAQ). Brand pages pass localized copy; routes default to the brand's
 * HelpCenter pages built from `feSlug`.
 */
const ShopEmptyState = ({
  variant = 'empty', // 'empty' | 'error'
  feSlug,
  title,
  text,
  contactLabel,
  faqLabel,
  contactTo,
  faqTo,
}) => {
  const navigate = useNavigate();
  const Icon = variant === 'error' ? CircleAlert : PackageOpen;
  const contactRoute = contactTo || `/clothing/${feSlug}/contact`;
  const faqRoute = faqTo || `/clothing/${feSlug}/faq`;

  return (
    <EmptyState
      className="school-shop__empty"
      icon={<Icon strokeWidth={1.25} />}
      title={title}
      message={text}
      actions={[
        { label: contactLabel, variant: 'black', size: 'secondary', iconRight: <ArrowRight size={18} />, onClick: () => navigate(contactRoute) },
        { label: faqLabel, variant: 'outline', size: 'secondary', iconRight: <ArrowRight size={18} />, onClick: () => navigate(faqRoute) },
      ]}
    />
  );
};

export default ShopEmptyState;
